module.exports = __webpack_public_path__ + "static/media/apk-badge.ff318419.svg";